import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UtilityService {
  public splitTextBySemiColon(text: string) {
    if (text != null) {
      return text.split(';');
    } else {
      return [];
    }
  }

  public convertEnterToLi(text: string) {
    const textRows: string[] = text.split('\n');
    let div = '<div><ul>';
    for (const row of textRows) {
      div += '<li>' + row + '</li>';
    }
    div += '</ul></div>';
    return div;
  }

  public splitTextByEnter(text: string) {
    if (text) {
      let array = text.split('\n');
      array = array.filter(x => x != "undefined")
      return array;
      // return text.split('\n');
    }
    else {
      return [];
    }
  }


  getPrimaryColor(type, selectedClientType, color?: string, secondColor?: string) {
    if (secondColor == null) {
      secondColor = "light"
    }
    if (color == null) {
      color = "primary";
    }
    if (type == selectedClientType) {
      return color;
    } else {
      return secondColor;
    }
  }

  changeSelectionType(type: string, selectedClientType) {
    selectedClientType = type;
  }

  public bloodGroupList: string[] = [
    'AB+',
    'AB−',
    'B+',
    'B−',
    'A+',
    'A−',
    'O+',
    'O−'
  ]
  public genderList: string[] = [
    'MALE',
    'FEMALE'
  ]
  public maritalStatusList: string[] = [
    "Married",
    "UnMarried"
  ]
  public verifiedStatusList: string[] = [
    "Verified"
  ]
  public monthList: string[] =
    ["APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
      "JAN",
      "FEB",
      "MAR"];

  public accountNameList: string[] = [
    'Subscription',
    'Loan',
    'Loan recovery',
    'Opening'
  ]

  getFileNameFromGCS(url) {
    return url.split("%2F").pop().split("?")[0];
  }
  public colorList = [
    { name: 'Red', hash: '#FF0000' },
    { name: 'Blue', hash: '#0000FF' },
    { name: 'Green', hash: '#006400' },
    { name: 'Orange', hash: '#FF6600' },
    { name: 'White', hash: '#FFFFFF' },
    { name: 'Black', hash: '#000000' },
    { name: 'Yellow', hash: '#FFFF00' },
    { name: 'Purple', hash: '#A020F0' },
    { name: 'Silver', hash: '#C0C0C0' },
    { name: 'Brown', hash: '#964B00' },
    { name: 'Gray', hash: '#808080' },
    { name: 'Pink', hash: '#FFC0CB' },
    { name: 'Navy Blue', hash: '#000080' },
    { name: 'Cyan', hash: '#00FFFF' },
    { name: 'Beige', hash: '#F5F5DC' },
    { name: 'Gold', hash: '#FFD700' },
  ];

  public columnList: string[] = [
    "occupation",
    "profession",
    "education",
  ];

  public occupationList: string[] = [
    "Government",
    "Private",
    "Self-Employed",
    "Business",
    "Homemaker",
    "Student",
    "Retired",
    "Other"
  ];

  public professionList: string[] = [
    "Lawyer",
    "Accountant",
    "Medical",
    "Doctor",
    "Engineer",
    "Teacher",
    "Chartered Accountant (CA)",
    "Manager",
    "Politician",
    "Businessman",
    "Farmer",
    "Defense Services",
    "Other"
  ];

  public educationList: string[] = [
    "Below 10th",
    "10th",
    "12th",
    "Graduate",
    "Postgraduate",
    "Doctorate",
    "Other"
  ];
  public educationObjectList: any[] = [
    { name: "Below 10th", value: "Below 10th" },
    { name: "10th", value: "10th" },
    { name: "12th", value: "12th" },
    { name: "Graduate", value: "Graduate" },
    { name: "Postgraduate", value: "Postgraduate" },
    { name: "Doctorate", value: "Doctorate" },
    { name: "Other", value: "Other" }
  ];

  public professionObjectList: any[] = [
    { name: "Lawyer", value: "Lawyer" },
    { name: "Accountant", value: "Accountant" },
    { name: "Medical", value: "Medical" },
    { name: "Doctor", value: "Doctor" },
    { name: "Engineer", value: "Engineer" },
    { name: "Teacher", value: "Teacher" },
    { name: "Chartered Accountant (CA)", value: "Chartered Accountant (CA)" },
    { name: "Manager", value: "Manager" },
    { name: "Politician", value: "Politician" },
    { name: "Businessman", value: "Businessman" },
    { name: "Farmer", value: "Farmer" },
    { name: "Defense Services", value: "Defense Services" },
    { name: "Other", value: "Other" }
  ];

  public occupationObjectList: any[] = [
    { name: "Government", value: "Government" },
    { name: "Private", value: "Private" },
    { name: "Self-Employed", value: "Self-Employed" },
    { name: "Business", value: "Business" },
    { name: "Homemaker", value: "Homemaker" },
    { name: "Student", value: "Student" },
    { name: "Retired", value: "Retired" },
    { name: "Other", value: "Other" }
  ]


  public raashi:string[] = [
    "मेष",
    "वृषभ",
    "मिथुन",
    "कर्क",
    "सिंह",
    "कन्या",
    "तुला",
    "वृश्चिक",
    "धनु",
    "मकर",
    "कुंभ",
    "मीन"
  ];

}
